export const DRIVER_GROUP_FORM_FIELD_IDS = {
  GROUP_NAME: 'driver-group-name',
  DRIVERS: 'driver-group-drivers'
};
